import { render } from "./GeteyesIntroduction.vue?vue&type=template&id=dc6dba6c"
import script from "./GeteyesIntroduction.vue?vue&type=script&lang=js"
export * from "./GeteyesIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__